import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback, useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Button from '@atlaskit/button/custom-theme-button';
import Heading from '@atlaskit/heading';
import { Box, Stack, Text } from '@atlaskit/primitives';
import SuccessContainer from './SuccessContainer';
export default (function (_ref) {
  var onAnswer = _ref.onAnswer;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    pending = _useState2[0],
    setPending = _useState2[1];
  var answeredWith = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(answer) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setPending(answer ? 'yes' : 'no');
            _context.next = 3;
            return onAnswer(answer);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [setPending, onAnswer]);
  var isDisabled = Boolean(pending);
  return jsx(SuccessContainer, null, jsx(Heading, {
    size: "xsmall"
  }, "Thanks for your feedback"), jsx(Box, {
    paddingBlockStart: "space.150"
  }, jsx(Stack, {
    space: "space.150"
  }, jsx(Text, {
    as: "p"
  }, "Are you interested in participating in our research?"), jsx(Text, {
    as: "p"
  }, "Sign up for the", ' ', jsx("a", {
    href: "https://www.atlassian.com/research-group"
  }, "Atlassian Research Group"), " and we may contact you in the future with research opportunities."))), jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: css({
      marginTop: "var(--ds-space-400, 32px)",
      display: 'flex',
      justifyContent: 'flex-end',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      '& > * + *': {
        marginLeft: "var(--ds-space-100, 8px)"
      }
    })
  }, jsx(Button, {
    appearance: "subtle",
    onClick: function onClick() {
      return answeredWith(false);
    },
    isDisabled: isDisabled,
    isLoading: pending === 'no'
  }, "No, thanks"), jsx(Button, {
    appearance: "primary",
    onClick: function onClick() {
      return answeredWith(true);
    },
    isDisabled: isDisabled,
    isLoading: pending === 'yes'
  }, "Yes, sign me up")));
});